import { Card, Table } from "react-bootstrap";
import { TopicStatistics } from "../types";
import { COLOR, STYLE } from "../../../config/constraits";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentClient } from "../../auth/api/getCurrentClient";
import { addFilter, saveBeforeFilter } from "../../../redux/filtersSlice";
import { GoThumbsdown, GoThumbsup } from "react-icons/go";
import { IoWarningOutline } from "react-icons/io5";
import { SelectedFilter } from "../../../components/Filters/types";
import { useTranslation } from "react-i18next";
import ChartShareActions from "../../../components/ChartShareActions";
import { RootState } from "../../../redux/store";
import { useRef } from "react";
import "./TopicsTable.css";
import { getSentimentValues } from "../../../utils/sentimentUtils";

interface TopicsTableProps {
    topics: TopicStatistics[]
}

export default function TopicsTable({ topics }: TopicsTableProps) {
  const navigate = useNavigate();
    const dispatch = useDispatch();
	const { t } = useTranslation('dashboard');

    const feelingchartRef = useRef<HTMLDivElement>(null);

	const { data: currentClient } = useCurrentClient();

    const handleTopicClick = (topicId: number, sentiment?: 'positive' | 'neutral' | 'negative' | 'alert') => {
		const topicFilters: SelectedFilter = {
            name: 'Topics',
            values: [topicId.toString()],
            description: t("dashboard:filters.Topics")
        };

		if (sentiment) {
			const values: string[] = getSentimentValues(sentiment, currentClient);
			const fieldName: string = sentiment != 'alert' ? "SentimentAI" : "AlertAI";
			
            topicFilters.relatedFilters = [{
				name: fieldName,
				values,
				description: `${topics.find(t => t.topicId == topicId)?.topicName} (${t(`dashboard:filters.${fieldName}`)})`
			}]
		}
		
		dispatch(saveBeforeFilter('dashboard'));
		dispatch(addFilter({ table: 'dashboard', filter: topicFilters }));

		navigate(`/survey-patient/historic`);
    }

    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

    return (
        <div ref={feelingchartRef}>
			<Card
				style={{
					backgroundColor: "#F5F5F5",
					border: "none",
					borderRadius: STYLE.BORDER_RADIUS,
				}}
				className="p-4 d-flex justify-content-center text-center"
			>
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h4 style={{ textAlign: "left" }}>{t("dashboard:trendingTopics")}</h4>
				<ChartShareActions
					chartRef={feelingchartRef}
					title={t("dashboard:trendingTopics")}
					filters={selectedFilters}
					t={t}
				/>
			</div>
				<Table responsive className="mt-3">
					<thead>
						<tr>
							<th style={{ textAlign: "left", border: "none" }}>{t("dashboard:topic.trendingTopicsTable1")}</th>
							<th style={{ whiteSpace: "nowrap", border: "none" }}>{t("dashboard:topic.trendingTopicsTable2")}</th>
							<th className="table-header-icon"> <GoThumbsup style={{ color: COLOR.VERD, fontSize: '24px' }} /></th>
							<th className="table-header-white-space"></th>
							<th className="table-header-icon"> </th>
							<th className="table-header-white-space"></th>
							<th className="table-header-icon"> <GoThumbsdown style={{ color: COLOR.VERMELL, fontSize: '24px' }} /></th>
							<th className="table-header-white-space"></th>
							<th className="table-header-icon"> <IoWarningOutline style={{ fontSize: '24px' }} /></th>
						</tr>
					</thead>
					<tbody>
						{topics.map((topic, index) => (
							<tr key={index}>
								<td className="table-row-cell" style={{ textAlign: "left", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }} onClick={() => handleTopicClick(topic.topicId)}>{topic.topicName}</td>
								<td className="table-row-cell">{topic.percentage?.toFixed()}%</td>
								<td className="table-row-cell" style={{ backgroundColor: COLOR.VERD_LIGHT, cursor: "pointer" }} onClick={() => handleTopicClick(topic.topicId, 'positive',)}>{topic.positiveComments}</td>
								<td></td>
								<td className="table-row-cell" style={{ backgroundColor: COLOR.TARONJA, cursor: "pointer" }} onClick={() => handleTopicClick(topic.topicId, 'neutral')}>{topic.neutralComments}</td>
								<td></td>
								<td className="table-row-cell" style={{ backgroundColor: COLOR.VERMELL_LIGHT, cursor: "pointer" }} onClick={() => handleTopicClick(topic.topicId, 'negative')} >{topic.negativeComments}</td>
								<td></td>
								<td className="table-row-cell" style={{ backgroundColor: topic.urgency > 0 ? COLOR.VERMELL_DARK : "white", color: topic.urgency > 0 ? "white" : "black", cursor: "pointer" }} onClick={() => handleTopicClick(topic.topicId, 'alert')} >{topic.urgency}</td>
							</tr>
						))}
					</tbody>
				</Table>
            </Card>
        </div>
  );
}
